
    
(() => {
  function positionTooltip(tooltip) {
    const tooltip_rect = tooltip.getBoundingClientRect();
    if ((tooltip_rect.x + tooltip_rect.width) > (window.innerWidth - 32)) {
      const overflow = tooltip_rect.x + tooltip_rect.width - (window.innerWidth - 32);
      tooltip.style.transform = `translateX(calc((50% + ${overflow}px) * -1))`;
    }
  }
  
  window.addEventListener('mouseover', (e) => {
    const hoveredEl = e.target.closest('[data-tooltip]');
    if (!hoveredEl || hoveredEl.querySelector('.tooltip') || window.matchMedia('(max-width: 980px)').matches) return;

    const thisId = hoveredEl.dataset.tooltip;
    const content = document.querySelector(`template[data-tooltip-content="${thisId}"]`)?.cloneNode(true)?.innerHTML;
        
    hoveredEl.style.zIndex = 50;
    hoveredEl.insertAdjacentHTML('afterBegin', `
      <div class="tooltip" role="tooltip">
        ${content}
      </div>
    `);
    
    positionTooltip(hoveredEl.querySelector('.tooltip'));
    
    hoveredEl.addEventListener('click', () => {
      hoveredEl.querySelector('input')?.click();
    }, { once: true });
    
    hoveredEl.addEventListener('mouseleave', () => {
      hoveredEl.style.zIndex = null;
      hoveredEl.querySelector('.tooltip')?.remove();
    }, { once: true });
  });
}) ();
  
    
